import { ApiErrorInitialState, } from '@hellodarwin/core/lib/features/entities';
import { createAsyncThunk, createEntityAdapter, createSlice, } from '@reduxjs/toolkit';
const grantStatisticsAdapter = createEntityAdapter({
    selectId: (model) => model.grant_id,
});
const acceptedApplicationsAdapter = createEntityAdapter({
    selectId: (model) => model.grant_id,
});
const grantStatisticsResponseAdapter = createEntityAdapter({
    selectId: (model) => model.grant_id,
});
const initialState = {
    status: 'idle',
    mappedStatus: {
        grantStatistics: 'idle',
        acceptedApplications: 'idle',
        grantStatisticsResponses: 'idle',
        fundingIntelligenceCompetition: 'idle',
    },
    error: ApiErrorInitialState,
    grantStatistics: grantStatisticsAdapter.getInitialState(),
    acceptedApplications: acceptedApplicationsAdapter.getInitialState(),
    grantStatisticsResponses: grantStatisticsResponseAdapter.getInitialState(),
    fundingIntelligenceCompetition: {
        companies: [],
        total: 0,
        limit: 0,
        offset: 0,
    },
};
export const fetchGrantStatistics = createAsyncThunk('client/fetchGrantStatistics', async ({ api, grantId }, { rejectWithValue }) => {
    try {
        return await api.fetchGrantStatistics(grantId);
    }
    catch (err) {
        return rejectWithValue(err.response.data);
    }
});
export const fetchAcceptedApplications = createAsyncThunk('client/fetchAcceptedApplications', async ({ api, grantId, limit, offset, industry, region, revenue, size, }, { rejectWithValue }) => {
    try {
        return await api.fetchAcceptedApplications(grantId, limit, offset, industry, region, revenue, size);
    }
    catch (err) {
        return rejectWithValue(err.response.data);
    }
});
export const fetchFundingIntelligenceStatistics = createAsyncThunk('client/fetchFundingIntelligenceStatistics', async ({ api, locale, limit, page, industry, region, revenue, size, query, }, { rejectWithValue }) => {
    try {
        return await api.fetchFundingIntelligenceStatistics(locale, limit, page, industry, region, revenue, size, query);
    }
    catch (err) {
        return rejectWithValue(err.response.data);
    }
});
export const fetchFundingIntelligenceCompetition = createAsyncThunk('client/fetchFundingIntelligenceCompetition', async ({ api, locale, limit, page, industry, region, revenue, size, query, }, { rejectWithValue }) => {
    try {
        return await api.fetchFundingIntelligenceCompetition(locale, limit, page, industry, region, revenue, size, query);
    }
    catch (err) {
        return rejectWithValue(err.response.data);
    }
});
const acceptedGrantsSlice = createSlice({
    name: 'accepted-grants',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchGrantStatistics.pending, (state) => {
            state.mappedStatus.grantStatistics = 'pending';
        });
        builder.addCase(fetchGrantStatistics.fulfilled, (state, { payload }) => {
            state.grantStatistics = grantStatisticsAdapter.upsertOne(state.grantStatistics, payload);
            state.mappedStatus.grantStatistics = 'idle';
        });
        builder.addCase(fetchGrantStatistics.rejected, (state, { payload }) => {
            state.error = payload !== null && payload !== void 0 ? payload : ApiErrorInitialState;
            state.mappedStatus.grantStatistics = 'idle';
        });
        builder.addCase(fetchAcceptedApplications.pending, (state) => {
            state.mappedStatus.acceptedApplications = 'pending';
        });
        builder.addCase(fetchAcceptedApplications.fulfilled, (state, { payload }) => {
            state.acceptedApplications = acceptedApplicationsAdapter.upsertOne(state.acceptedApplications, payload);
            state.mappedStatus.acceptedApplications = 'idle';
        });
        builder.addCase(fetchAcceptedApplications.rejected, (state, { payload }) => {
            state.error = payload !== null && payload !== void 0 ? payload : ApiErrorInitialState;
            state.mappedStatus.acceptedApplications = 'idle';
        });
        builder.addCase(fetchFundingIntelligenceStatistics.pending, (state) => {
            state.mappedStatus.grantStatisticsResponses = 'pending';
        });
        builder.addCase(fetchFundingIntelligenceStatistics.fulfilled, (state, { payload }) => {
            state.grantStatisticsResponses = grantStatisticsResponseAdapter.setAll(state.grantStatisticsResponses, payload !== null && payload !== void 0 ? payload : []);
            state.mappedStatus.grantStatisticsResponses = 'idle';
        });
        builder.addCase(fetchFundingIntelligenceStatistics.rejected, (state, { payload }) => {
            state.error = payload !== null && payload !== void 0 ? payload : ApiErrorInitialState;
            state.mappedStatus.grantStatisticsResponses = 'idle';
        });
        builder.addCase(fetchFundingIntelligenceCompetition.pending, (state) => {
            state.mappedStatus.fundingIntelligenceCompetition = 'pending';
        });
        builder.addCase(fetchFundingIntelligenceCompetition.fulfilled, (state, { payload }) => {
            state.fundingIntelligenceCompetition = payload;
            state.mappedStatus.fundingIntelligenceCompetition = 'idle';
        });
        builder.addCase(fetchFundingIntelligenceCompetition.rejected, (state, { payload }) => {
            state.error = payload !== null && payload !== void 0 ? payload : ApiErrorInitialState;
            state.mappedStatus.fundingIntelligenceCompetition = 'idle';
        });
    },
});
export const selectAcceptedGrantsError = (state) => { var _a; return (_a = state.acceptedGrants) === null || _a === void 0 ? void 0 : _a.error; };
export const selectAcceptedApplicationsLoading = (state) => { var _a, _b; return ((_b = (_a = state.acceptedGrants) === null || _a === void 0 ? void 0 : _a.mappedStatus) === null || _b === void 0 ? void 0 : _b.acceptedApplications) === 'pending'; };
export const selectGrantsStatisticsLoading = (state) => { var _a, _b; return ((_b = (_a = state.acceptedGrants) === null || _a === void 0 ? void 0 : _a.mappedStatus) === null || _b === void 0 ? void 0 : _b.grantStatistics) === 'pending'; };
export const selectGrantsStatisticsResponseLoading = (state) => { var _a, _b; return ((_b = (_a = state.acceptedGrants) === null || _a === void 0 ? void 0 : _a.mappedStatus) === null || _b === void 0 ? void 0 : _b.grantStatisticsResponses) === 'pending'; };
export const selectFundingIntelligenceCompetitionLoading = (state) => {
    var _a, _b;
    return ((_b = (_a = state.acceptedGrants) === null || _a === void 0 ? void 0 : _a.mappedStatus) === null || _b === void 0 ? void 0 : _b.fundingIntelligenceCompetition) ===
        'pending';
};
export const { selectAll: selectGrantStatistics, selectById: selectGrantStatisticsById, } = grantStatisticsAdapter.getSelectors((state) => {
    var _a, _b;
    return (_b = (_a = state.acceptedGrants) === null || _a === void 0 ? void 0 : _a.grantStatistics) !== null && _b !== void 0 ? _b : grantStatisticsAdapter.getInitialState();
});
export const { selectAll: selectAcceptedApplications, selectById: selectAcceptedApplicationsById, } = acceptedApplicationsAdapter.getSelectors((state) => {
    var _a, _b;
    return (_b = (_a = state.acceptedGrants) === null || _a === void 0 ? void 0 : _a.acceptedApplications) !== null && _b !== void 0 ? _b : acceptedApplicationsAdapter.getInitialState();
});
export const { selectAll: selectGrantStatisticsResponses, selectById: selectGrantStatisticsResponsesById, } = grantStatisticsResponseAdapter.getSelectors((state) => {
    var _a, _b;
    return (_b = (_a = state.acceptedGrants) === null || _a === void 0 ? void 0 : _a.grantStatisticsResponses) !== null && _b !== void 0 ? _b : grantStatisticsResponseAdapter.getInitialState();
});
export const selectIndustryByGrantId = (grantId) => (state) => { var _a; return (_a = selectGrantStatisticsById(state, grantId)) === null || _a === void 0 ? void 0 : _a.industry; };
export const selectLocationByGrantId = (grantId) => (state) => { var _a; return (_a = selectGrantStatisticsById(state, grantId)) === null || _a === void 0 ? void 0 : _a.location; };
export const selectRevenueByGrantId = (grantId) => (state) => { var _a; return (_a = selectGrantStatisticsById(state, grantId)) === null || _a === void 0 ? void 0 : _a.revenue; };
export const selectSizeByGrantId = (grantId) => (state) => { var _a; return (_a = selectGrantStatisticsById(state, grantId)) === null || _a === void 0 ? void 0 : _a.size; };
export const selectTotalByGrantId = (grantId) => (state) => { var _a; return ((_a = selectGrantStatisticsById(state, grantId)) === null || _a === void 0 ? void 0 : _a.total) || 0; };
export const selectFundingIntelligenceCompetition = (state) => { var _a; return (_a = state.acceptedGrants) === null || _a === void 0 ? void 0 : _a.fundingIntelligenceCompetition; };
export const acceptedGrantsReducer = acceptedGrantsSlice.reducer;
